import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client';
import { RichText } from 'prismic-reactjs';
import './Publications.css';
import {mapKeys} from 'lodash';

const Publications = ({client}) => {

    const [doc, setDoc] = useState([]);
    const [type, setType] = useState("1. Patent");
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'publications_summary')
            )
            if (response) {
                setSummary(response.results[0]);
            }
            }
            fetchData()
    }, [client]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'publications'), {orderings : '[my.publications.type]'}
            )
            if (response) {
                setDoc(response.results);
            }
            }
            fetchData()
    }, [client]);

    if(doc.length > 0 && summary){
        const publications = mapKeys(doc, d => d.data.type);
        return (
            <div className="Publications">
                <h2>Overview</h2>
                <div>
                    <RichText render={summary.data.summary}/>
                </div>
                <div>
                <h2>Publications</h2>
                </div>
                <div className="menu">
                    <ul>
                        {doc.map(d => <li key={d.id} className={type === d.data.type ? 'selected' : ''} onClick={() => setType(d.data.type)}>{d.data.type}</li>)}
                    </ul>
                </div>
                <p>* means student or visiting scholar author</p>
                <div className="details">
                    <RichText render={publications[type].data.details} />
                </div>
            </div>
        )
    } else {
        return <div className="Publications">Loading...</div>;
    }
    
};
export default Publications;